export default "__VITE_ASSET__a213b84c__"